// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  getDictionaryPending: false,
  getDictionaryError: null,
  dictionaries: [],
  brands: [],
  models: [],
  normalizedAndTerms: '',
  dictionaryCreate: '',
  batchResults: [],
  batchCount: 0,
  categories: [],
  dictionaryRowData: null,
  years: [],
  versions: [],
  data: [],
  commonCategories: [],
  commonNormalizedTextsLast: [],
  brandModelNormalizedTextOptions: [],
  actDeleteDictionaryPending: false,
  actDeleteDictionaryError: null,
  actGetBrandsPending: false,
  actGetBrandsError: null,
  actGetModelsPending: false,
  actGetModelsError: null,
  actPostDictionaryPending: false,
  actPostDictionaryError: null,
  actGetNormalizedWithTermsPending: false,
  actGetNormalizedWithTermsError: null,
  actCreateNormalizedAndTermsPending: false,
  actCreateNormalizedAndTermsError: null,
  actDeleteVersionDictionaryNormalizedPending: false,
  actDeleteVersionDictionaryNormalizedError: null,
  actGetCommonCategoriesPending: false,
  actGetCommonCategoriesError: null,
  actGetYearsPending: false,
  actGetYearsError: null,
  actGetVersionsPending: false,
  actGetVersionsError: null,
  actPostCarSearchPending: false,
  actPostCarSearchError: null,
  actBatchSearchResultPending: false,
  actBatchSearchResultError: null,
  actBatchCountPending: false,
  actBatchCountError: null,
  actGetDictionaryCategoriesPending: false,
  actGetDictionaryCategoriesError: null,
  actGetNormalizedTextsPending: false,
  actGetNormalizedTextsError: null,
  actGetBrandModelNormalizedPending: false,
  actGetBrandModelNormalizedError: null,
  actPostSaveTermPending: false,
  actPostSaveTermError: null,
  actBatchFindToCsvPending: false,
  actBatchFindToCsvError: null,
  actConfiguration: {},
  actConfigurationError: null,
  actConfigurationPending: false,
  unsavedChanges: false,
  modalConfirmationUsdData: {
    isOpen: false, 
    openedFromSearchButton: false, 
    openedFromSidebar: false,
    nextLocation: null, 
    saveChanges: null,
    discardChanges: null,
  },
}

export default initialState
